import { render, staticRenderFns } from "./labelPopulation.vue?vue&type=template&id=7a24231a&scoped=true&"
import script from "./labelPopulation.vue?vue&type=script&lang=js&"
export * from "./labelPopulation.vue?vue&type=script&lang=js&"
import style0 from "./labelPopulation.vue?vue&type=style&index=0&id=7a24231a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a24231a",
  null
  
)

export default component.exports